class Client {

    constructor( {api, store}) {
        if (!api) {
            return new Error(`Missing backend api`);
        }
        if (!store) {
            return new Error(`Missing store`);
        }
        this.api = api;
        this.store = store;
    }

    getClient() {
        var state = this.store.getState();
        return state.client.clientJson;
    }

    getClientId() {
        var client = this.getClient();
        return client ? client.clientId : null;
    }

    ////////////////
    ////// API /////
    ////////////////

    getClientFromAPI(clientId) {
        return this.api.getClient(clientId || this.getClientId());
    }

    uploadCallback(url, params){
        return this.api.uploadCallback(url, params);
    }

    /**
     * @param {string} documentName 
     * @param {string} documentPurpose 
     * @param {string} documentType 
     * @param {object} [extra] Extra data to store with the particular document.
     */
    generateUploadUrl(documentName, documentPurpose, documentType, extra) {
        return this.api.generateClientUploadUrl(
            documentName,
            documentPurpose,
            documentType,
            this.getClientId(),
            extra
        );
    }

}

export default Client;
